export const NAT_COLLECTION = 'tap-DMT-NAT'
export interface NatTerms {
	protocol: 'tap'
	ticker: 'DMT-NAT'
	token_amount: string
	total_price_sats: string
	/** Display truncated at 12 decimal places; total/amount is binding. */
	sats_per_nat: string
}
const SCALE = BigInt('1000000000000000000')
export function natAmount(value: string): bigint | null {
	if (value.length > 39 || !/^\d+(?:\.\d{1,18})?$/.test(value)) return null
	const [whole, frac = ''] = value.split('.')
	const n = BigInt(whole) * SCALE + BigInt(frac.padEnd(18, '0'))
	return n > BigInt(0) && n <= BigInt('340282366920938463463374607431768211455') ? n : null
}
export function btcSats(value: string): number {
	if (!/^\d+(?:\.\d{1,8})?$/.test(value)) return 0
	const [whole, frac = ''] = value.split('.')
	const n = BigInt(whole) * BigInt(100000000) + BigInt(frac.padEnd(8, '0'))
	return n <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(n) : 0
}
export function natTerms(tokens: string, price: number): NatTerms | null {
	const amount = natAmount(tokens)
	if (!amount || !Number.isSafeInteger(price) || price <= 0) return null
	const n = BigInt(price) * SCALE
	let unit = String(n / amount)
	let remainder = n % amount
	if (remainder) {
		unit += '.'
		for (let i = 0; i < 12; i++) {
			remainder *= BigInt(10)
			unit += String(remainder / amount)
			remainder %= amount
			if (!remainder) break
		}
		unit = unit.replace(/0+$/, '').replace(/\.$/, '')
	}
	return {
		protocol: 'tap',
		ticker: 'DMT-NAT',
		token_amount: tokens,
		total_price_sats: String(price),
		sats_per_nat: unit
	}
}

/** Unit-price input to whole satoshis. Never silently round a buyer's price. */
export function natBidTotal(tokens: string, satsPerToken: string): number | null {
	if (!/^\d+$/.test(tokens)) return null
	const amount = natAmount(tokens)
	const unit = natAmount(satsPerToken)
	if (!amount || !unit) return null
	const numerator = amount * unit
	const divisor = SCALE * SCALE
	if (numerator % divisor !== BigInt(0)) return null
	const sats = numerator / divisor
	return sats > BigInt(0) && sats <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(sats) : null
}
export function formatNatAmount(value: string): string {
	const [whole, fraction] = value.split('.')
	return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (fraction ? `.${fraction}` : '')
}
